var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-group"},[(_vm.field.attrs && _vm.field.attrs.label)?_c('label',{attrs:{"for":_vm.inputId}},[_vm._v(_vm._s(_vm.field.attrs.label))]):_vm._e(),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":_vm.inputId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }